const getStudentEnrollmentQuery = (version, studentUids, isDemoClass) => {
    return `query StudentEnrollmentQuery {
        getStudentEnrollment_${version}(student_uids: "${studentUids.join(
        ',',
    )}", with_demo: ${isDemoClass}) {
          gradeYears {
            year
            grade
          }
          studentUid
        }
      }`;
};

export default getStudentEnrollmentQuery;
